var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-container"},[_c('div',{class:{
    'buttons-tab' : _vm.style === 'default',
    'buttons-group' : _vm.style === 'button' || _vm.style === 'button-bordered',
    'button-bordered' : _vm.style === 'button-bordered',
    'button-small': _vm.size === 'small',
    'button-large': _vm.size === 'large'
    }},_vm._l((_vm.items),function(item,index){return _c('m-button',{key:item.id,attrs:{"active":index === _vm.mutableActive},nativeOn:{"click":function($event){_vm.onClick(index)}}},[_vm._v(_vm._s(item.title))])})),_vm._v(" "),_c('div',{staticClass:"tabs"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-7964dcbc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/Tab.vue
// module id = null
// module chunks = 